module.exports = __webpack_public_path__ + "static/media/mm.c22f7c51.svg";